import { render, staticRenderFns } from "./main-gate.vue?vue&type=template&id=9f023700&scoped=true&"
import script from "./main-gate.vue?vue&type=script&lang=js&"
export * from "./main-gate.vue?vue&type=script&lang=js&"
import style0 from "./main-gate.vue?vue&type=style&index=0&id=9f023700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f023700",
  null
  
)

export default component.exports